// extracted by mini-css-extract-plugin
export default {"risk-slider":"RiskSlider_risk-slider__vF7XV","risk-value-label":"RiskSlider_risk-value-label__DY2qB","risk-label":"RiskSlider_risk-label__Co68r"};